// import { MuiOtpInput } from 'mui-one-time-password-input';
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import OtpInput from 'react-otp-input';

const OTPInput = ({ name, label, control, defaultValue, helperText, disabled, ...props }) => {
  return (
    <Controller
      render={({ field: { onChange, value } }) => (
        <OtpInput
          value={value}
          onChange={onChange}
          numInputs={4}
          shouldAutoFocus={true}
          inputType="tel"
          renderInput={(props) => (
            <TextField
              sx={{ m: 1 }}
              width={'45px'}
              height={'45px'}
              inputProps={{ ...props }}
              disabled={disabled}
            />
          )}
        />
      )}
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      {...props}
    />
  );
};

export default OTPInput;
